import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form';

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Date from '../../Form/Field/Date.jsx';
import Input from '../../Form/Field/Input.jsx';
import Select from '../../Form/Field/Select.jsx';

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';


import CityTypeahead from "../../Form/Field/CityTypeahead.jsx";
import CitiesTypeahead from "../../Form/Field/CitiesTypeahead.jsx";
import normBoolean from "../../Form/Normalizer/boolean.js";
import validate from './validate.js';

import './FreelanceInterviewConfirmInfoForm.scss'


export const name = 'FreelanceInterviewConfirmInfoForm';

class FreelanceInterviewConfirmInfoForm extends PureComponent {

  render() {
    const {localConf} = this.props

    return <div id={name} className={'additional-info-step-form'}>
      <form autoComplete="off" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="mb-auto col-md-6">
            <div className="d-flex flex-wrap justify-content-around bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2 ">
              <h5 className="mx-auto py-2">Disponibilité</h5>

              <div className="row">
                <div className="col-5"><label htmlFor="freelance.date_available">Date de disponibilité *</label></div>
                <div className="col-7">
                  <Field
                    label=""
                    name="freelance.date_available"
                    placeholder="JJ/MM/AAAA"
                    type="text"
                    component={Date}
                    className={'inline'}
                  />
                </div>
              </div>

              <Field
                label="Commentaire"
                name="freelance.date_available_tunnel_comment"
                type="textarea"
                component={Input}
              />

              <Field
                label="Autorisation de travail"
                name="freelance.work_permit"
                type="select"
                component={Select}
              >
                {Object.entries(localConf.workPermits).map(([key, workPermit]) => (
                  <option value={workPermit.value} key={key}>{workPermit.label}</option>
                ))}
              </Field>

              <Field
                label="Statut professionnel"
                name="freelance.situation"
                type="select"
                component={Select}
              >
                {Object.entries(localConf.situations).map(([key, situation]) => (
                  <option value={situation.value} key={key}>{situation.label}</option>
                ))}
              </Field>
            </div>
          </div>

          <div className="mb-auto col-md-6">
            <div className="d-flex flex-wrap  bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2 ">
              <h5 className="mx-auto py-2">Mobilité</h5>
              <div className="col-12">
                <div className="row">
                  <div className="col-5"><label htmlFor="user.city">J'habite à *</label></div>
                  <div className="col-7">
                    <Field
                      label=""
                      name="user.city"
                      placeholder="Paris, Bordeaux..."
                      autocomplete="off"
                      type="text"
                      component={CityTypeahead}
                    />
                  </div>
                </div>
                <Field
                  label="Commentaires mobilité "
                  name="freelance.relocation_long_fulltime_comment"
                  type="textarea"
                  component={Input}
                />

                <Field
                  label="Je veux travailler dans la région de"
                  name="user.work_cities"
                  autocomplete="off"
                  type="text"
                  component={CitiesTypeahead}
                />

                <div className="col-12  relocation-long-fulltime">
                  <Field
                    label="Mobilité France entière"
                    name="freelance.relocation_long_fulltime"
                    type="checkbox"
                    normalize={normBoolean}
                    component={Input}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-auto col-md-6">
            <div className="d-flex flex-wrap  bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2 ">
              <h5 className="mx-auto py-2">TJM</h5>
              <div className="row">
                <div className="col-6">
                  <Field
                    label={<span>
                  TJM minimum
                    </span>}
                    name="freelance.price"
                    type="number"
                    component={Input}
                  />
                </div>

                <div className="col-6">
                  <Field
                    label="Equivalent brut"
                    name="freelance.yearly_brut"
                    type="number"
                    component={Input}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-auto col-md-6">
            <div className="bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2 ">
              <h5 className="mx-auto py-2 text-center">Autre</h5>

              <div className="row align-items-center">
                <div className="col-12 col-md-8">
                  <Field
                    label="Lien de votre profil LinkedIn"
                    name="user.linkedin_url"
                    type="text"
                    component={Input} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="">Photo</label>
                    {this.props.uploadUserImageForm &&
                    this.props.uploadUserImageForm
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <input className="d-none" type="submit"/>
        <FormGlobalErrors className="mt-0" errors={this.props.error}/>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </div>;
  }
}

export default reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name),
})(FreelanceInterviewConfirmInfoForm);
